import { logger } from "@otto-ec/global-resources/debug";

export const moduleLogger = logger("benefit.cinema");
